import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { Header } from "@molecules";
import Footer from "../components/atoms/Footer/footer";
import styled from "styled-components";
import { useIsMobile } from "../hooks";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const excludeUrls = [
  "/login",
  "/policy",
  "/register",
  "/register-check-email",
  "/recovery",
  "/recovery-password",
  "/recovery-check-email",
];

const Wrapper = styled.div`
  width: 100%;

  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = Cookies.get("access");
  const location = useLocation();
  const isMobile = useIsMobile();

  if (excludeUrls.includes(location.pathname)) {
    return <>{children}</>;
  }

  if (!token && (!location.pathname.includes("/stories") && !location.pathname.includes("/feedback") && location.pathname !== "/")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <Wrapper>
      <Header />
      {children}
      {!isMobile && <Footer />}
    </Wrapper>
  );
};

export default ProtectedRoute;
